const mapSearchStatsToTable = (searchSummary, translation) => {
    const dataCols = [
        {
            id: 'actualWhat', numeric: false, disablePadding: false, label: translation.WHAT, defaultSorting: false,
        },
        {
            id: 'actualWhere', numeric: false, disablePadding: false, label: translation.WHERE, defaultSorting: false,
        },
        {
            id: 'count', numeric: true, disablePadding: false, label: translation.COUNT, defaultSorting: true,
        },
    ];

    const dataRows = searchSummary.map((summary) => {
        const id = summary.search;

        const {
            count,
            actualWhat,
            actualWhere,
        } = summary;

        return {
            id,
            actualWhat,
            actualWhere: actualWhere === '' ? translation.NATIONWIDE : actualWhere,
            count,
        };
    });

    return {
        dataCols,
        dataRows,
    };
};

export default mapSearchStatsToTable;
